import { Box, CssBaseline, Paper } from "@mui/material";
import "./App.css";
import { withTheme } from "./assets/theme/ThemeWrapper";
import Footer from "./components/Footer";
import Layout from "./components/Layout";
import ThemeToogler from "./components/themeToogler/ThemeToogler";
import ContactPage from "./pages/contactPage";
import Services from "./pages/OurServices";
import PortfolioPresentation from "./pages/presentation";

function App(props) {
  const { darkMode, setDarkMode } = props;
  return (
    <Paper
      elevation={0}
      square
      sx={{
        margin: 0,
        padding: 0,
        minhHeight: "100vh",
        height: "100%",
        position: "relative",
      }}
    >
      <CssBaseline />
      <PortfolioPresentation />
      <Layout>
        <Services />
        <ContactPage />
      </Layout>
      <Box
        sx={{
          position: "fixed",
          bottom: "1rem",
          right: "1rem",
          zIndex: 99,
        }}
      >
        <ThemeToogler darkMode={darkMode} setDarkMode={setDarkMode} />
      </Box>
      <Footer />
    </Paper>
  );
}

export default withTheme(App);
